import { render, staticRenderFns } from "./GameMain.vue?vue&type=template&id=55392ef6&"
import script from "./GameMain.vue?vue&type=script&lang=js&"
export * from "./GameMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports